export enum TBCCBrokerTierEnum {
  pro = 'TPR',
  lite = 'TBA',
}
